export const authStatuses = {
  AUTHENTICATED: 'authenticated',
  UNAUTHENTICATED: 'unauthenticated',
  EXPIRED: 'expired',
  NOT_AVAILABLE: 'notAvailable',
}